import { ReactElement } from "react";
import { match } from "ts-pattern";
import { UseQueryResult } from "react-query";
import { NoData } from "ui-components";

type GetValueProps = {
  connection: UseQueryResult<any, unknown>;
  children: ReactElement;
};

const ValueWithSkeleton: React.FC<GetValueProps> = ({ connection, children }) => {
  return match(connection)
    .with({ status: "loading" }, { status: "idle" }, () => (
      <div style={{ height: "30px", width: "100%" }} className="bp5-skeleton" />
    ))
    .with({ status: "error" }, () => (
      <NoData title="No Data" iconDisable = {false} descriptionDisable={false} flexDir="row" translateY={10}/>
    ))
    .with({ status: "success" }, ({ data }) =>
      !data || Object.keys(data).length === 0 ? (
        <NoData title="No Data" iconDisable = {false} descriptionDisable={false} flexDir="row" translateY={0}/>
      ) : (
        <>{children}</>
      )
    )
    .exhaustive();
};

export default ValueWithSkeleton;
